module.exports = __webpack_public_path__ + "img/default.4e1bd43d.jpg";